import styled from "styled-components";

export const AnchorInner = styled.a`
	position: relative;

	/* Top of -5.5em to account for size of page header (3.5em) and extra 2em to move the target page area away from the very top of the page, for readability */
	top: -5.5em;
`;
